import { useSortable } from '@dnd-kit/sortable';
import React from 'react';
import FormBuilderGroup from '../form-builder-group.component';

interface FormBuilderGroupProps {
  groupId: number | string;
}

const FormBuilderGroupWrapper = ({ groupId }: FormBuilderGroupProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: groupId,
    data: {
      type: 'group',
      groupId,
    },
  });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const accordionClassName = isDragging ? 'cursor-grabbing' : 'cursor-pointer';
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <FormBuilderGroup key={groupId} groupId={groupId} className={accordionClassName} />
    </div>
  );
};

export default React.memo(FormBuilderGroupWrapper);
